<form-wrapper>
  <div mat-dialog-content>
    <img
      src="assets/img/aide-numero-fiscal.png"
      alt="Numéro Fiscal"
      height="590px"
      width="1115px"
    />
  </div>
</form-wrapper>
